<div class="buysellcontrol_wrapper buysellcontrol_wrapper_buy">
    <app-view-balance [buyorsell]="'buy'"></app-view-balance>
    <app-marketorder-form [buyorsell]="'buy'"></app-marketorder-form>
</div>
<div class="buysellcontrol_wrapper buysellcontrol_wrapper_sell">
    <app-view-balance [buyorsell]="'sell'"></app-view-balance>
    <app-marketorder-form [buyorsell]="'sell'"></app-marketorder-form>
</div>